import cx from 'classnames';
import { CtaButton, Subtitle } from 'themes/organic/components/index';

import s from './GiftCard.module.css';

interface GiftCardProps {
  className?: string;
}

const GiftCard = ({ className }: GiftCardProps) => {
  return (
    <section className={cx(s.root, className)}>
      <Subtitle>Giftcards</Subtitle>
      <div className={s.buyContainer}>
        <CtaButton href="/gift-cards" style={2} title="buy here">
          buy here
        </CtaButton>
      </div>
    </section>
  );
};

export { GiftCard };
